import { RoleUserModel } from '@/core/services/Token/model/TokenModel'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import AccountService from '../AccountService'
import {
  UserEmailCompleteValidationModel,
  UserModel,
} from '../models/UserModel'

export interface AccontState {
  currentUser: UserModel | null
  isAuth: boolean
  role: RoleUserModel
  // it doesn't change on selecting reseller
  userRole: RoleUserModel
  connectedResellerId: string
}

const initialState: AccontState = {
  currentUser: null,
  isAuth: true,
  role: RoleUserModel.User,
  userRole: RoleUserModel.User,
  connectedResellerId: '',
}

export const getCurrentUserThunk = createAsyncThunk(
  'accont/getCurrentUserThunk',
  async (_, { rejectWithValue }) => {
    try {
      return await AccountService.getCurrentUser()
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const updateCurrentUserThunk = createAsyncThunk(
  'accont/updateCurrentUserThunk',
  async (data: UserModel, { rejectWithValue }) => {
    try {
      return await AccountService.updateCurrentUser(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const completeVerificationThunk = createAsyncThunk(
  'accont/completeVerificationThunk',
  async (data: UserEmailCompleteValidationModel, { rejectWithValue }) => {
    try {
      return await AccountService.userEmailCompleteValidation(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getUserRoleThunk = createAsyncThunk(
  'accont/getUserRoleThunk',
  async (userId: string, { rejectWithValue }) => {
    try {
      return await AccountService.getUserRole(userId)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const authSlice = createSlice({
  name: 'accont',
  initialState,
  reducers: {
    changeAuth(state, action) {
      state.isAuth = action.payload
    },
    changeRole(state, action) {
      state.role = action.payload
    },
    setConnectedResellerId(state, action) {
      state.connectedResellerId = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCurrentUserThunk.fulfilled, (state, action) => {
        state.currentUser = action.payload
      })
      .addCase(getCurrentUserThunk.rejected, state => {
        state.currentUser = null
      })

      .addCase(updateCurrentUserThunk.fulfilled, (state, action) => {
        state.currentUser = action.payload
      })

      .addCase(getUserRoleThunk.fulfilled, (state, action) => {
        state.userRole = action.payload.roleId
      })
      .addCase(getUserRoleThunk.rejected, state => {
        state.userRole = RoleUserModel.User
      })
  },
})

export const { actions, reducer } = authSlice
export const { changeAuth, changeRole, setConnectedResellerId } = actions
